import React from "react";
import Tab from "../common/Tab/Tab";
import TabItem from "../common/Tab/TabItem";

function MavTabs(props: any) {
    return (
        <Tab tabId="mav-tabs">
            <TabItem title="Risks" link="/mav/risk" tabNo="1" selectedTab={props.selectedTab} />
            <TabItem title="Devices" link="/mav/devices" tabNo="2" selectedTab={props.selectedTab} />
        </Tab>
    );
}

export default MavTabs;
